import { Controller } from "@hotwired/stimulus"

// After Stripe Checkout, the success URL often loads before the webhook has
// written the membership/pass. When still pending, reload a few times until
// the server says the record is ready (or we hit max attempts).
export default class extends Controller {
  static values = {
    pending: { type: Boolean, default: false },
    interval: { type: Number, default: 1500 },
    maxAttempts: { type: Number, default: 8 }
  }

  connect() {
    if (!this.pendingValue) return

    const params = new URLSearchParams(window.location.search)
    const attempts = Number(params.get("wait") || "0")
    if (Number.isNaN(attempts) || attempts >= this.maxAttemptsValue) return

    this.timer = window.setTimeout(() => {
      params.set("wait", String(attempts + 1))
      const query = params.toString()
      const next = query ? `${window.location.pathname}?${query}` : window.location.pathname
      // Full navigation so we never serve a Turbo-cached empty membership view.
      window.location.replace(next)
    }, this.intervalValue)
  }

  disconnect() {
    if (this.timer) window.clearTimeout(this.timer)
  }
}
